define('gumbo-js-client-lib/forms/gameData/GameForm',{
	pk: null,
	id: null,
	doubleHeader: null,
	type: null,
	gamedayType: null,
	tiebreaker: null,
	gameNumber: null,
	calendarEventID: null
});
